import { APP_VERSION } from './app-version';

export const environment = {
  production: true,

  name: "Production",

  app: APP_VERSION,

  scormPackageWithLegalMentions: "6,30,61,62,152,162,200,237,243",
  scormPackageTMD: "68,210,225,232",

  Redirect_Page_Maintenance: 'https://apps.novosst.com/maintenance/',
  api_LMS: 'https://novo.studio/api/',
  SSO_Redirect_Uri: 'https://novo.studio/auth-callback',
  SSO_Silent_Redirect_Uri: 'https://novo.studio/silent-callback',
  SSO_Post_Logout_Redirect_Uri: 'https://novo.studio/',
  SSO_Profil: 'https://connexion.novosst.com/connexion/',
  SSO_ConnexionPage_Uri: 'https://connexion.novosst.com/connexion/'
};
